
import { mapState, mapGetters } from "vuex";
import reportPrintTitleReportName from "./report-print-title-report-name.vue";
export default {
  components: { reportPrintTitleReportName },
  props: {
    title: {
      default: ""
    }
  },
  computed: {
    ...mapState("report", ["selectedStartDate", "selectedEndDate"]),
    ...mapGetters("report", ["getSelectedRestaurantsLabel"]),
    ...mapState("auth", ["user"]),
    ...mapState("restaurant", ["locationDetails"]),
    now() {
      return new Date();
      // return moment(new Date()).format("YYYY-MM-DD HH:mm");
    }
  }
};
